import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Col, Row } from 'reactstrap';
import InputComponent from '../InputComponent';
import Toast from "../../helpers/Toast";
import ButtonComponent from "../ButtonComponent";
import { CreateAssistanceServiceTripsDTO } from "../../models/AssistanceServiceTrips/CreateAssistanceServiceTripsDTO";
import { AssistanceServiceTripsService } from "../../services/AssistanceServiceTripsService";
import { Utilities } from "../../helpers/Utilities";
import SelectComponent from "../SelectComponent";
import { SelectItemsProps } from "../Select2Component";
import AssistanceServiceTripsTable from "./AssistanceServiceTripsTable";

export type AssistanceServiceTripsComponentProps = {
    assistanceId: number | null;
    totalDebtkmInAssistance: number | null;
}

const AssistanceServiceTripsComponent = ({ assistanceId, totalDebtkmInAssistance }: AssistanceServiceTripsComponentProps) => {
    const defaultTrip: CreateAssistanceServiceTripsDTO = {
        idAssistance: assistanceId,
        originAddress: null,
        destinationAddress: null,
        originDate: null,
        destinationDate: null,
        idDestinationType: 0,
        idOriginType: 0,
        totalKm: null,
    };

    const intl = useIntl();
    const assistanceServiceTripsService = new AssistanceServiceTripsService();
    const [trip, setTrip] = useState<CreateAssistanceServiceTripsDTO>(defaultTrip);
    const [isCreateButtonLoading, setIsCreateButtonLoading] = useState<boolean>(false);
    const [tripTypesList, setTripTypesList] = useState<SelectItemsProps[]>([]);
    const [selectedOriginType, setSelectedOriginType] = useState<number | null>(Utilities.LoadParameterFromURLQuery("idOriginType", "number", ""));
    const [selectedDestinationType, setSelectedDestinationType] = useState<number | null>(Utilities.LoadParameterFromURLQuery("idDestinationType", "number", ""));
    const [startTime, setStartTime] = useState<string>("00:00");
    const [endTime, setEndTime] = useState<string>("00:00");

    const [reload, setReload] = useState<boolean>(false);

    const getTripTypesList = async () => {
        var response = await assistanceServiceTripsService.GetTypes("Deslocation");
        if (response.success === false || response.obj === null) {
            Toast.Show("error", response.message);
            return [];
        }

        const list: SelectItemsProps[] = [];

        response.obj.forEach((element: any) => {
            var item: SelectItemsProps = {
                value: element.id,
                label: element.name
            };
            list.push(item);
        });
        setTripTypesList(list)
    }

    const CreateAssistanceTrip = async () => {
        const originDateTime = trip?.originDate ? Utilities.CombineDateAndTime(trip.originDate, startTime) : null;
        const destinationDateTime = trip?.destinationDate ? Utilities.CombineDateAndTime(trip.destinationDate, endTime) : null;

        const CreateAssistanceTrip: CreateAssistanceServiceTripsDTO = {
            idAssistance: assistanceId,
            originAddress: trip?.originAddress ?? null,
            destinationAddress: trip?.destinationAddress ?? null,
            originDate: originDateTime,
            destinationDate: destinationDateTime,
            idDestinationType: selectedDestinationType ?? 0,
            idOriginType: selectedOriginType ?? 0,
            totalKm: trip?.totalKm,
        };

        const response = await assistanceServiceTripsService.Create(CreateAssistanceTrip);

        if (response.success !== true) {
            Toast.Show("error", response.message);
            setIsCreateButtonLoading(false);
            return;
        }

        Toast.Show("success", response.message);
        setIsCreateButtonLoading(false);

        setTrip(defaultTrip)
        setSelectedOriginType(null);
        setSelectedDestinationType(null);
        setStartTime("00:00");
        setEndTime("00:00");
        setReload(!reload);
    };

    useEffect(() => {
        getTripTypesList();
    }, [])

    return (
        <div>
            { }
            <Row
                style={{
                    margin: "0px",
                    marginTop: "10px",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <label style={{ margin: "0px", padding: "13px", fontSize: "15px" }}>
                    <b>
                        <FormattedMessage id="Screens.AssistanceServiceTripsComponent.Origin" />
                    </b>
                </label>
            </Row>

            <Row
                style={{
                    margin: "0px",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <SelectComponent
                    xl={3}
                    lg={3}
                    md={3}
                    sm={12}
                    xs={12}
                    style={{ width: "100%", height: "43px" }}
                    label={intl.formatMessage({ id: "Screens.AssistanceServiceTripsComponent.OriginType" })}
                    selectedItemValue={selectedOriginType?.toString() ?? null}
                    items={tripTypesList}
                    onChange={(value: string | number) => {
                        setSelectedOriginType(Number(value));
                    }}
                />

                <InputComponent
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"text"}
                    value={trip?.originAddress}
                    label={intl.formatMessage({ id: "Screens.AssistanceServiceTripsComponent.OriginAddress" })}
                    readOnly={isCreateButtonLoading}
                    onChange={(originAddress: string) => {
                        setTrip({ ...trip!, originAddress: originAddress });
                    }}
                />

                <InputComponent
                    xl={2}
                    lg={2}
                    md={2}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"date"}
                    value={trip?.originDate == null ? "" : Utilities.formatDateYYYYMMDD(new Date(trip.originDate))}
                    label={intl.formatMessage({ id: "Screens.AssistanceServiceTripsComponent.OriginDate" })}
                    readOnly={isCreateButtonLoading}
                    onChange={(originDate: Date) => {
                        setTrip({ ...trip!, originDate });
                    }}
                />

                <InputComponent
                    xl={2}
                    lg={2}
                    md={2}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"time"}
                    value={startTime}
                    label={intl.formatMessage({ id: "Screens.Assistances.AditionalInfo.Label.HoraInicio" })}
                    readOnly={isCreateButtonLoading}
                    onChange={(t: string) => {
                        setStartTime(t);
                    }}
                />

            </Row>

            <Row
                style={{
                    margin: "0px",
                    marginTop: "10px",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >

                <label style={{ margin: "0px", padding: "13px", fontSize: "15px" }}>
                    <b>
                        <FormattedMessage id="Screens.AssistanceServiceTripsComponent.Destination" />
                    </b>
                </label>
            </Row>


            <Row
                style={{
                    margin: "0px",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <SelectComponent
                    xl={3}
                    lg={3}
                    md={3}
                    sm={12}
                    xs={12}
                    style={{ width: "100%", height: "43px" }}
                    label={intl.formatMessage({ id: "Screens.AssistanceServiceTripsComponent.DestinationType" })}
                    selectedItemValue={selectedDestinationType?.toString() ?? null}
                    items={tripTypesList}
                    onChange={(value: string | number) => {
                        setSelectedDestinationType(Number(value));
                    }}
                />

                <InputComponent
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"text"}
                    value={trip?.destinationAddress}
                    label={intl.formatMessage({ id: "Screens.AssistanceServiceTripsComponent.DestinationAddress" })}
                    readOnly={isCreateButtonLoading}
                    onChange={(destinationAddress: string) => {
                        setTrip({ ...trip!, destinationAddress: destinationAddress });
                    }}
                />

                <InputComponent
                    xl={2}
                    lg={2}
                    md={2}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"date"}
                    value={trip?.destinationDate == null ? "" : Utilities.formatDateYYYYMMDD(new Date(trip.destinationDate))}
                    label={intl.formatMessage({ id: "Screens.AssistanceServiceTripsComponent.DestinationDate" })}
                    readOnly={isCreateButtonLoading}
                    onChange={(destinationDate: Date) => {
                        setTrip({ ...trip!, destinationDate });
                    }}
                />

                <InputComponent
                    xl={2}
                    lg={2}
                    md={2}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"time"}
                    value={endTime}
                    label={intl.formatMessage({ id: "Screens.Assistances.AditionalInfo.Label.HoraFim" })}
                    readOnly={isCreateButtonLoading}
                    onChange={(t: string) => {
                        setEndTime(t);
                    }}
                />

            </Row>

            <Row
                style={{
                    margin: "0px",
                    marginTop: "10px",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <InputComponent
                    xl={2}
                    lg={2}
                    md={2}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"number"}
                    value={trip?.totalKm}
                    label={intl.formatMessage({ id: "Screens.Assistances.AditionalInfo.Label.Distanciakm" })}
                    readOnly={isCreateButtonLoading}
                    onChange={(totalKm: number) => {
                        setTrip({ ...trip!, totalKm: totalKm });
                    }}
                />
            </Row>

            <Row style={{ margin: "0px", padding: "0px", justifyContent: "end" }}>
                <Col xl={3} lg={3} md={3} sm={12} xs={12}>
                    <ButtonComponent
                        style={{ width: "100%", marginTop: "10px" }}
                        text={intl.formatMessage({ id: "AssistanceServiceTripsComponent.Create" })}
                        onClick={() => CreateAssistanceTrip()}
                        disabled={isCreateButtonLoading}
                    />
                </Col>
            </Row>

            <Row
                style={{
                    margin: "0px",
                    marginTop: "25px",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <AssistanceServiceTripsTable
                    assistanceId={assistanceId ?? 0}
                    reload={reload}
                    totalDebtkmInAssistance={totalDebtkmInAssistance ?? 0}
                />
            </Row>

        </div >
    )
}

export default AssistanceServiceTripsComponent